
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salon-finder",
      function () {
        return require("private-next-pages/salon-finder.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/salon-finder"])
      });
    }
  